import {
  defaultBackgroundSetting,
  defaultBorderSetting,
  defaultBorderRadiusSetting,
  defaultBoxShadowSetting,
  defaultComplexFontSetting,
  defaultPaddingSetting
} from "@/materials/navMenu/render/customSubMenus/setting/defaultSetting"
export const props = [
  {
    name: "numberText",
    desc: "文字",
    type: "complexFontSet",
    defaultValue: {
      ...defaultComplexFontSetting,
      colorMode: "complex",
      textAlign: "center",
      fontFamily: "Roboto-Regular",
      fontSize: 36,
      fontWeight: 600,
      lineHeight: 39,
      fontColor: {
        data: {
          stops: [
            ["rgba(254,254,254,1)", 0],
            ["rgba(0,0,0,1)", 1]
          ],
          angle: 0
        },
        type: "color",
        color: "rgba(254,254,254,1)",
        label: "颜色"
      }
    },
    extraConfig: {
      showFontTypeSetting: false,
      showTextAlignSetting: false,
      hideHighLevelSetting: true,
      showMoreBtn: false
    }
  },
  {
    name: "numberBackground",
    desc: "背景",
    type: "backgroundSet",
    defaultValue: [
      {
        data: {
          stops: [
            ["rgba(71,76,89,1)", 0],
            ["rgba(246,206,1,1)", 1]
          ],
          angle: 0
        },
        type: "color",
        color: "rgba(71,76,89,1)",
        isThemeColor: false,
        label: "颜色"
      }
    ],
    extraConfig: {
      title: "图片&渐变"
    }
  },
  {
    name: "numberBorder",
    desc: "边框",
    type: "borderSet",
    defaultValue: {
      ...defaultBorderSetting,
      showEnableCheckbox: true
    }
  },
  {
    name: "numberRadius",
    desc: "圆角",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting,
      borderRadius: 6
    }
  },
  {
    name: "numberOpacity",
    desc: "透明度",
    type: "numberSet",
    defaultValue: 100,
    formatter(val) {
      return val / 100
    },
    extraConfig: {
      suffix: "%"
    }
  },
  {
    name: "numberShadow",
    desc: "阴影",
    type: "shadowSet",
    defaultValue: {
      ...defaultBoxShadowSetting
    },
    extraConfig: {
      title: "阴影"
    }
  },
  {
    name: "numberPadding",
    desc: "内边距",
    type: "paddingSet",
    defaultValue: {
      ...defaultPaddingSetting,
      padding: 8
    }
  }
]

export const menuSetting = [
  {
    type: "collapse",
    title: "文字",
    settings: ["numberText"]
  },
  {
    type: "collapse",
    title: "背景",
    settings: ["numberBackground"]
  },
  {
    type: "collapse",
    title: "边框",
    initStatus: "closed",
    settings: [
      {
        type: "basic",
        name: "numberBorder"
      },
      "numberRadius"
    ]
  },
  {
    type: "collapse",
    title: "边距",
    initStatus: "closed",
    settings: ["numberPadding"]
  },
  {
    type: "collapse",
    title: "更多",
    initStatus: "closed",
    settings: ["numberOpacity", "numberShadow"]
  }
]
